<template>
    <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            :fullscreen="windowWidth < 700">

        <div class="clearfix mb-2">
            <div class="float-right">
                <el-tooltip class="item" effect="dark" :content="getPaymentMessage" placement="top-start">
                    <el-checkbox v-model="obj.enrollmentPaid" label="Betaald" border :disabled="userEdit || !this.$store.getters.isTreasurer"></el-checkbox>
                </el-tooltip>
            </div>
            <div class="float-right mr-2">
                <el-tooltip class="item" effect="dark" content="Tijd en datum inschrijving" placement="top-start">
                    <el-input :readonly="true"
                              prefix-icon="el-icon-date"
                              :value="getCreatedAt">
                    </el-input>
                </el-tooltip>
            </div>
        </div>

        <el-form :model="obj" ref="addEditForm" status-icon :rules="rules"> <!--:rules="rules"-->
            <el-tabs v-model="activeName">
                <!-- General -->
                <el-tab-pane label="Personalia" name="general">
                    <el-row :gutter="10">
                        <el-col :span="6">
                            <el-form-item prop="gender">
                                <el-select v-model="obj.gender" placeholder="Geslacht" class="w-full" :disabled="readOnly">
                            <span slot="prefix">
                                <div v-if="obj.gender">
                                    <i class="el-icon-male pl-1"></i>
                                </div>
                                <div v-else>
                                    <i class="el-icon-female pl-1"></i>
                                </div>
                            </span>
                                    <el-option
                                            v-for="item in genderOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="firstName">
                                <el-input placeholder="Voornaam" v-model="obj.firstName" :disabled="readOnly"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="lastName">
                                <el-input placeholder="Achternaam" v-model="obj.lastName" :disabled="readOnly"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item prop="email">
                                <el-input placeholder="Email" v-model="obj.email" type="email"
                                          prefix-icon="el-icon-message" :disabled="readOnly || userEdit"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="cellPhone">
                                <el-input placeholder="Telefoon" v-model="obj.cellPhone"
                                          prefix-icon="el-icon-mobile-phone" :disabled="readOnly"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item prop="birthDate">
                                <el-date-picker
                                        v-model="obj.birthDate"
                                        type="date"
                                        class="w-full"
                                        placeholder="Geboortedatum"
                                        :disabled="readOnly">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="nationality">
                                <el-input placeholder="Nationaliteit" v-model="obj.nationality" :disabled="readOnly"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-form-item prop="street">
                                <el-input placeholder="Straat" v-model="obj.street" :disabled="readOnly"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item prop="number">
                                <el-input placeholder="Nummer" v-model="obj.number" :disabled="readOnly"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item prop="postal">
                                <el-input placeholder="Postcode" v-model="obj.postal" :disabled="readOnly"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item prop="city">
                                <el-input placeholder="Stad" v-model="obj.city" :disabled="readOnly"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item prop="country">
                                <el-select v-model="obj.country"
                                           placeholder="Land"
                                           class="w-full"
                                           :disabled="readOnly">
                                         <span slot="prefix">
                                            <i class="el-icon-location-outline pl-1"></i>
                                        </span>
                                    <el-option
                                            v-for="item in countryOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="branchId">
                                <el-select v-model="obj.branchId"
                                           placeholder="Tak"
                                           class="w-full"
                                           :disabled="readOnly || userEdit">
                                     <span slot="prefix">
                                            <i class="el-icon-medal pl-1"></i>
                                     </span>
                                    <el-option
                                            v-for="item in branchOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-tab-pane>

                <!-- Emergencies -->
                <el-tab-pane label="Noodgevallen" name="emergencies">
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item prop="emgFirstName">
                                <el-input placeholder="Voornaam" v-model="obj.emgFirstName" :disabled="readOnly"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="emgLastName">
                                <el-input placeholder="Achternaam" v-model="obj.emgLastName" :disabled="readOnly"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item prop="emgCellPhone">
                                <el-input placeholder="Telefoon" v-model="obj.emgCellPhone"
                                          prefix-icon="el-icon-mobile-phone" :disabled="readOnly"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-tab-pane>

                <!-- Other -->
                <el-tab-pane label="Andere" name="others">
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item prop="accountNumber">
                                <el-input placeholder="Rekeningnummer" v-model="obj.accountNumber"
                                          prefix-icon="el-icon-bank-card" :disabled="readOnly"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="nationalInsuranceNumber">
                                <el-input placeholder="Rijksregisternummer" v-model="obj.nationalInsuranceNumber"
                                          prefix-icon="el-icon-user" :disabled="readOnly"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item prop="formations">
                                <el-input type="textarea"
                                          v-model="obj.formations"
                                          placeholder="Opleidingen en vormingen"
                                          maxlength="60"
                                          show-word-limit :disabled="readOnly"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item prop="annotations">
                                <el-input type="textarea"
                                          v-model="obj.annotations"
                                          placeholder="Opmerkingen"
                                          maxlength="60"
                                          show-word-limit :disabled="readOnly"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane label="Admin" name="admin" :disabled="readOnly" v-if="!userEdit">
                    <el-button type="primary" icon="el-icon-magic-stick" @click="generateAccount()" :loading="loading">Maak account</el-button>
                </el-tab-pane>
            </el-tabs>
        </el-form>

        <!-- Footer -->
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">Annuleer</el-button>
            <el-button type="primary" @click="submitForm('addEditForm')" :loading="loading">Opslaan</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import moment from 'moment'
    export default {
        name: "EnrollmentAdminDialog",
        props: {
            // Content
            value: String,

            // Number with a default value
            userEdit: {
                type: Boolean,
                default: false
            },

            readOnly: {
                type: Boolean,
                default: false
            },

            current: {
                type: String,
            },

            branchOptions: {
                type: Array
            }
        },
        data() {
            return {
                dialogTitle: "",
                itemName: "Inschrijving",
                dialogVisible: false,
                adding: false,
                obj: this.getEmptyObject(),
                loading: false,
                activeName: "general",
                windowWidth: window.innerWidth,

                // RulesPerStep
                formPerStep: [
                    'personalForm',
                    'emergencyForm',
                    'otherForm'
                ],

                // Options
                genderOptions: [
                    {
                        value: true,
                        label: "Man"
                    }, {
                        value: false,
                        label: "Vrouw"
                    }
                ],
                countryOptions: [
                    {
                        value: 0,
                        label: "België"
                    },
                    {
                        value: 1,
                        label: "Nederland"
                    }
                ],

                // Rules
                rules: {
                    firstName: [
                        {required: true, message: 'Vul een naam in.', trigger: 'blur'}
                    ],
                    lastName: [
                        {required: true, message: 'Vul een achternaam in.', trigger: 'blur'}
                    ],
                    email: [
                        {type: 'email', required: true, message: 'Vul een geldig email adres in.', trigger: 'blur'}
                    ],
                    cellPhone: [
                        {required: true, message: 'Vul een telefoonnummer in.', trigger: 'blur'}
                    ],
                    gender: [
                        {required: true, message: 'Selecteer een geslacht.', trigger: 'blur'}
                    ],
                    birthDate: [
                        {required: true, message: 'Selecteer een geboortedatum.', trigger: 'blur'}
                    ],
                    street: [
                        {required: true, message: 'Vul een straat in.', trigger: 'blur'}
                    ],
                    number: [
                        {required: true, message: 'Vul nummer in.', trigger: 'blur'}
                    ],
                    city: [
                        {required: true, message: 'Vul een stad in.', trigger: 'blur'}
                    ],
                    postal: [
                        {required: true, message: 'Vul postcode in.', trigger: 'blur'}
                    ],
                    nationality: [
                        {required: true, message: 'Vul een nationaliteit in.', trigger: 'blur'}
                    ],
                    branchId: [
                        {required: true, message: 'Selecteer een tak.', trigger: 'blur'}
                    ],
                    region: [
                        {required: true, message: 'Vul een regio in.', trigger: 'blur'}
                    ],
                    country: [
                        {required: true, message: 'Selecteer een land.', trigger: 'blur'}
                    ],
                    emgFirstName: [
                        {required: true, message: 'Vul naam contactpersoon in.', trigger: 'blur'}
                    ],
                    emgLastName: [
                        {required: true, message: 'Vul achternaam contactpersoon in.', trigger: 'blur'}
                    ],
                    emgCellPhone: [
                        {required: true, message: 'Vul telefoonnummer contactpersoon in.', trigger: 'blur'}
                    ],
                    nationalInsuranceNumber: [
                        {required: true, message: 'Vul rijksregisternummer in.', trigger: 'blur'}
                    ],
                    accountNumber: [
                        {required: true, message: 'Vul rekeningnummer in.', trigger: 'blur'}
                    ]
                }
            }
        },
        mounted() {
            window.onresize = () => {
                this.windowWidth = window.innerWidth
            }
        },
        methods: {
            edit(obj) {
                this.dialogTitle = `${this.itemName} wijzigen`
                this.dialogVisible = true
                this.adding = false
                this.obj = JSON.parse(JSON.stringify(obj));
                this.reset();
            },
            add() {
                this.dialogTitle = `${this.itemName} toevoegen`
                this.dialogVisible = true
                this.adding = true
                this.obj = this.getEmptyObject()
                this.reset();
            },
            reset() {
                if (this.$refs['addEditForm']) {
                    this.$refs['addEditForm'].resetFields()
                }
            },
            getEmptyObject() {
                return {
                    // Form data
                    firstName: "",
                    lastName: "",
                    roles: "",
                    email: "",
                    cellPhone: "",
                    gender: null,
                    birthDate: "",
                    street: "",
                    number: "",
                    city: "",
                    postal: "",
                    region: "",
                    country: "",
                    nationality: "",
                    branches: "",
                    emgFirstName: "",
                    emgLastName: "",
                    emgCellPhone: "",
                    nationalInsuranceNumber: "",
                    accountNumber: "",
                    formations: "",
                    annotations: "",
                    enrollmentPaid: false,
                }
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        if (this.adding) {
                            this.$parent.objAdded(this.obj);
                        } else {
                            this.$parent.objEdited(this.obj);
                        }
                    } else {
                        return false;
                    }
                });
            },
            close() {
                this.loading = false;
                this.dialogVisible = false;
            },
            openAlert(msg, type) {
                this.$message({
                    showClose: true,
                    message: msg,
                    type: type
                });
                return false;
            },
            generateAccount() {
                this.loading = true
                this.$http.post('admin/users/', this.obj)
                    .then((response) => {
                        this.loading = false
                        this.openAlert("Account succesvol gegenereerd.", "success")
                    }).catch((error) => {
                        this.loading = false
                        if(error.response.status === 409) {
                            this.openAlert("Email adres reeds in gebruik!", "error")
                        } else {
                            this.openAlert("Kon account niet aanmaken, probeer later opnieuw.", "error")
                        }
                    })
            }
        },
        computed: {
            getCreatedAt() {
                return moment(this.obj.createdAt).format('DD-MM-YYYY HH:mm')
            },
            getPaymentMessage() {
                if (this.obj.enrollmentPaid) {
                    return "Lid heeft inschrijvingsgeld betaald"
                }

                return "Lid heeft inschrijvingsgeld niet betaald"
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/dashboard/enrollments/dialogs/EnrollmentAdminDialog.vue